var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        no: "ReleaseJY",
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.ReleaseJY"),
        "close-on-click-modal": false,
        width: "500px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.dialogClose
      }
    },
    [
      _c("div", { staticStyle: { margin: "10px", fontWeight: "bold" } }, [
        _c("span", [_vm._v(_vm._s(_vm.job.mbl))])
      ]),
      _c(
        "div",
        { staticStyle: { flex: "1", margin: "10px", fontWeight: "bold" } },
        [
          _c("span", [_vm._v(_vm._s(_vm.job.vessel))]),
          _c("span", { staticStyle: { "margin-left": "10px" } }, [
            _vm._v(_vm._s(_vm.job.voyageFlight))
          ])
        ]
      ),
      _c("div", { staticStyle: { fontWeight: "bold", margin: "10px" } }, [
        _c("span", [_vm._v(" " + _vm._s(_vm.containerDesc))])
      ]),
      _c("div", { staticStyle: { display: "flex", "margin-top": "20px" } }, [
        _c(
          "span",
          {
            style: {
              margin: "5px",
              width: _vm.$selectByLang(
                "50px",
                "50px",
                "50px",
                "70px",
                "70px",
                "70px"
              )
            }
          },
          [_vm._v(_vm._s(_vm.$t("SeaExport.ReleaseRemarks")))]
        ),
        _c(
          "div",
          { staticStyle: { width: "70%", "margin-left": "10px" } },
          [
            _c("el-input", {
              attrs: { type: "textarea", rows: 5, no: "remark" },
              model: {
                value: _vm.remark,
                callback: function($$v) {
                  _vm.remark = $$v
                },
                expression: "remark"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticStyle: { display: "flex", "margin-top": "20px" } }, [
        _c(
          "span",
          {
            style: {
              margin: "5px",
              width: _vm.$selectByLang(
                "50px",
                "50px",
                "50px",
                "70px",
                "70px",
                "70px"
              )
            }
          },
          [_vm._v(_vm._s(_vm.$t("SeaExport.RequireDate")))]
        ),
        _c(
          "div",
          { staticStyle: { width: "50%", "margin-left": "10px" } },
          [
            _c("el-date-picker", {
              staticStyle: { width: "100%" },
              attrs: {
                no: "45",
                type: "datetime",
                "value-format": "yyyy-MM-dd HH:mm:ss",
                format: "yyyy-MM-dd HH:mm"
              },
              model: {
                value: _vm.requireDate,
                callback: function($$v) {
                  _vm.requireDate = $$v
                },
                expression: "requireDate"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.jyRelease()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c("el-button", { on: { click: _vm.dialogClose } }, [
            _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }